import { GatsbyImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import Header from "../components/property/header"
import Layout from "../components/layout"
import Enquire from "../components/property/enquire"
import Seo from "../components/seo"
import Model from "../components/property/model"
import { HiCamera } from "react-icons/hi"
import Separator from "../utils/separator"
import { FaBed, FaUserFriends } from "react-icons/fa"
export default function Property({ pageContext: { data }, location }) {
  //   console.log(data.frontmatter.images[1])

  const [active, setActive] = useState(0)
  const [action, setAction] = useState(false)

  const image = data.cover
  const metaImage = {
    src: image.asset.url,
    width: image.asset.metadata.dimensions.width,
    height: image.asset.metadata.dimensions.height,
  }

  const Open = id => {
    setActive(id)
    setAction(true)
  }

  return (
    <Layout>
      <Seo
        image={metaImage}
        title={data.name}
        description={data.shortDescription}
        pathname={location.pathname}
      />
      {action ? (
        <Model
          image={data.images}
          setActive={setActive}
          active={active}
          setAction={setAction}
          title={data.title}
        />
      ) : null}
      <Header image={image.asset.gatsbyImageData} title={data.title} />
      <div className="max-w-6xl w-11/12 xl:w-full mx-auto flex justify-end relative -top-6 z-50 ">
        <button
          onClick={() => setAction(true)}
          className="bg-teal-600 text-white p-2 rounded text-3xl shadow-lg shadow-teal-600/30"
        >
          <HiCamera />
        </button>
      </div>
      <div className="max-w-6xl mx-auto w-11/12 xl:w-full py-12 md:py-20 divide-y">
        <div className="flex flex-col gap-4 pb-4">
          <span className="text-xl font-serif">{data.name}</span>
          <p className="text-base font-light">{data.services}</p>
          <p className="italic">
            <strong className="not-italic">Starting from:</strong>{" "}
            {Separator(data.price)}
            /week
          </p>
          <div className="flex gap-5 items-center">
            {data.beds && (
              <div className="flex flex-col items-center space-y-1">
                <FaBed className="text-xl text-stone-500" />
                <span className="text-xs">{data.beds} Bedrooms</span>
              </div>
            )}
            {data.guests && (
              <div className="flex flex-col items-center space-y-1">
                <FaUserFriends className="text-xl text-stone-500" />
                <span className="text-xs">{data.guests} Guests</span>
              </div>
            )}
          </div>
        </div>
        <div className="py-12">
          <strong>What we offer:</strong>
          <ul className="flex flex-wrap items-center gap-4 py-4">
            {data.features.map((feature, key) => {
              return (
                <li
                  key={key}
                  className="truncate text-xs px-4 py-2 rounded-full bg-stone-200"
                >
                  {feature.name}
                </li>
              )
            })}
          </ul>
        </div>
        {data.images && (
          <div className="py-6">
            <h3 className="text-xl md:text-3xl pb-3 capitalize text-teal-600">
              Gallery:
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {data.images.map((image, key) => {
                return (
                  <button
                    onClick={() => Open(key)}
                    key={key}
                    className="h-64 w-full outline-none focus:outline-none relative"
                  >
                    <GatsbyImage
                      className="h-full object-cover w-full relative z-0"
                      image={image.asset.gatsbyImageData}
                      alt={`${data.name} - ${key}`}
                    />
                    {active !== key && (
                      <div className="absolute transition duration-500 ease-in-out top-0 left-0 h-full w-full bg-opacity-75 hover:bg-opacity-40 bg-black z-20" />
                    )}
                  </button>
                )
              })}
            </div>
          </div>
        )}
      </div>
      <Enquire book={true} />
    </Layout>
  )
}
